import { DownloadTypeFormController } from '../controller/DownloadTypeFormController';
import { BaseWebComponentElement } from '../../../../../framework/BaseWebComponentElement';
import { PackageGeneralFormController } from '../../../../../packages/common/packageGeneralForm/controller/PackageGeneralFormController';
import { Observable } from 'rxjs';
import { DownloadTypeFormValue } from '../types';

export class DownloadTypeFormWebComponent extends BaseWebComponentElement {
  public controller!: PackageGeneralFormController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: DownloadTypeFormController,
    });
  }

  public get value(): DownloadTypeFormValue {
    return this.controller.view.formGroup.value as DownloadTypeFormValue;
  }

  public get valid$(): Observable<boolean> {
    return this.controller.view.formGroup.valid$;
  }
}
